import {
  GET_EXCO_PROVINSI,
  GET_EXCO_PROVINSI_SUCCESS,
  GET_EXCO_PROVINSI_FAIL,
} from "./actionTypes";

const initialState = {
  dataProvinsi: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXCO_PROVINSI:
      return {
        ...state,
        dataProvinsi: {
          ...state.dataProvinsi,
          loading: true,
          error: false,
          isLoggedIn: false,
        },
      };
    case GET_EXCO_PROVINSI_SUCCESS:
      return {
        ...state,
        dataProvinsi: {
          ...state.dataProvinsi,
          loading: false,
          error: false,
          isLoggedIn: true,
          data: action.payload,
        },
      };
    case GET_EXCO_PROVINSI_FAIL:
      return {
        ...state,
        dataProvinsi: {
          ...state.dataProvinsi,
          loading: false,
          error: action.payload,
          isLoggedIn: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
